import React, { useEffect, useState } from "react";
import Button from "../../Components/Button";
import Modal from "../../Components/Modal/Modal";
import TextInput from "../../Components/TextInput";
import { IApplyOptionConfig } from "../../Interfaces/applyOption";
import {
  getApplyOptionConfig,
  setApplyOptionConfig,
} from "../../Requests/applyOption";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { CheckBox } from "src/Components";

const Config = ({ onSaved }: { onSaved?: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formValues, setFormValues] = useState({} as IApplyOptionConfig);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    getApplyOptionConfig()
      .then((resp) => {
        setFormValues(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, [isOpen]);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const submitHandler = () => {
    setLoading(true);
    setApplyOptionConfig({
      ...formValues,
      applyRemainedDay: formValues.applyRemainedDay,
    })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          setIsOpen(false);
          onSaved?.();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const modalUI = (
    <div className="grid grid-cols-2 gap-x-4 gap-y-5 items-end">
      <TextInput
        label="درصد حاشیه اعمال کال"
        name="applyCallMargin"
        value={formValues.applyCallMargin?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="درصد حاشیه اعمال پوت"
        name="applyPutMargin"
        value={formValues.applyPutMargin?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="تعداد روز مانده"
        name="applyRemainedDay"
        value={formValues.applyRemainedDay?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <CheckBox
        checked={formValues.workerEnabled}
        label="اعمال اتوماتیک"
        name="workerEnabled"
        onChange={changeHandler}
      />
      <div />
      <Button onClick={submitHandler} text="ثبت" variant="contained" />
    </div>
  );

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      {isOpen ? (
        <Modal
          onClose={() => setIsOpen(false)}
          UI={modalUI}
          modalBoxClassName="!min-w-[0px]"
        />
      ) : (
        <></>
      )}
      <div className="w-36">
        <Button
          text="تنظیمات اعمال"
          variant="contained"
          onClick={() => setIsOpen(true)}
        />
      </div>
    </>
  );
};

export default Config;
